import { jsx } from '@amazon/vinyl-tsx'
import { navigateTo } from '@/router/router'
import { getString } from '@/notFound/i18n/bundle.generated'

const ERROR_HEADPHONES_LOGO_URL =
    'https://m.media-amazon.com/images/G/01/digital/music/player/recs-error-headphones'

export function NotFound() {
    return (
        <div className="notFoundPage">
            <p className="notFoundPrimary">{getString('dmusic_not_found_primary_text')}</p>
            <a
                className="notFoundLink"
                href="/"
                onclick={(e: MouseEvent) => {
                    e.preventDefault()
                    navigateTo('/')
                }}
            >
                {getString('dmusic_not_found_secondary_text_link')}
            </a>
            <a
                className="notFoundLink"
                href="/search"
                onclick={(e: MouseEvent) => {
                    e.preventDefault()
                    navigateTo('/search')
                }}
            >
                {getString('dmusic_not_found_search_link')}
            </a>
            <img
                className="notFoundImage"
                src={ERROR_HEADPHONES_LOGO_URL}
                alt=""
                aria-hidden="true"
            />
        </div>
    )
}
